import React from 'react';

interface CropMaskProps {
    left: number;
    top: number;
    width: number;
    height: number;
    cropShape: 'rect' | 'round';
}

const CropMask: React.FC<CropMaskProps> = (props) => {
    const {left, top, width, height, cropShape} = props;

    return (
        <div className="absolute inset-0 pointer-events-none">
            <svg width="100%" height="100%">
                <defs>
                    <mask id="cropMask">
                        <rect width="100%" height="100%" fill="white"/>
                        {cropShape === 'round' ? (
                            <circle
                                cx={left + width / 2}
                                cy={top + height / 2}
                                r={Math.min(width, height) / 2}
                                fill="black"
                            />
                        ) : (
                            <rect x={left} y={top} width={width} height={height} fill="black"/>
                        )}
                    </mask>
                </defs>
                <rect width="100%" height="100%" fill="rgba(0,0,0,0.5)" mask="url(#cropMask)"/>
            </svg>
        </div>
    );
};

export default CropMask;
